<template>
  <div class="full-area has-image gps-wrapper">
    <div class="">
      <div class="geo-button-wrapper">
        <h2>Antes de empezar esta encuesta</h2>
        <p>Esta encuesta requiere acceso al GPS</p>
        <el-button
          type="danger"
          @click="getLocation"
          v-if="!gettingLocation && !geoActive"
        >
          Activar geolocalización
        </el-button>
        <el-button
          type="danger"
          disabled
          class="disabled-button"
          v-if="gettingLocation && !geoActive"
        >
          Procesando...
        </el-button>
      </div>
      <div class="geo-message-wrapper">
        <transition-group name="fade">
          <p v-if="geoError" key="error">{{geoError}}</p>
          <h2 v-if="geoActive" key="success">¡Listo!</h2>
        </transition-group>
      </div>
      <div class="geo-cancel-wrapper delay-entry" v-if="showGeoCancelAction">
        <a @click="proceedWithoutGPS">Continuar sin GPS</a>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'GPS',

  data () {
    return {
      gettingLocation: false,
      geoGPS: {},
      geoActive: false,
      geoError: '',
      showGeoCancelAction: false
    }
  },
  methods: {
    getLocation() {
      this.gettingLocation = true
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition( (position) => {
          this.geoActive = true
          this.geoError = ''
          this.geolocation = {
            type: "Point",
            coordinates: [position.coords.longitude, position.coords.latitude] 
          };
          this.$store.commit('STORE_OFFLINE_GEOLOCATION', { geo: this.geolocation })
        }, () => {
          this.handleLocationError(`Debe aceptar compartir su ubicación. En la configuración del sitio en su navegador, habilite la ubicación para ${process.env.VUE_APP_BASE_URL} y refresque la página para poder continuar.`);
        });
      } else {
        this.handleLocationError('Su navegador no parece tener soporte de geolocalización. Intente con otro dispositivo.');
      }
    },    
    handleLocationError(message) {
      this.geoError = message
    },
    proceedWithoutGPS () {
      this.geolocation = {
        type: "Unknown",
        coordinates: [0, 0] 
      };
      this.$store.commit('STORE_OFFLINE_GEOLOCATION', { geo: this.geolocation })

    }
  },
  mounted () {
    setTimeout(() => {
      this.showGeoCancelAction  = true
    }, 3000)
  }
}
</script>

<style scoped lang="scss">
.gps-wrapper {
  z-index: 2000;
}
.geo-message-wrapper {
  margin-top: 10px;
}
.geo-cancel-wrapper {
  position: fixed;
  bottom: 15px;
  left: 0;
  right: 0;
  font-size: 18px;
}
.geo-button-wrapper {
  flex-direction: column;
  h2 {
    font-size: 22px;
  }
  p {
    font-size: 18px;
  }
}
</style>
<style lang="scss">
.disabled-button {
  background-color: $gray-medium !important;
  border-color: $gray-medium !important;
  &:hover {
    background-color: $gray-medium !important;
    border-color: $gray-medium !important;
  }
}
</style>